import { render, staticRenderFns } from "./CustomFilterSelectYearsV2.vue?vue&type=template&id=06b8afa2&scoped=true"
import script from "./CustomFilterSelectYearsV2.vue?vue&type=script&lang=js"
export * from "./CustomFilterSelectYearsV2.vue?vue&type=script&lang=js"
import style0 from "./CustomFilterSelectYearsV2.vue?vue&type=style&index=0&id=06b8afa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b8afa2",
  null
  
)

export default component.exports